module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-google-analytics-438.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-google-analytics.md
// module id = 878
// module chunks = 226